// Gerado por scripts/build-icons.mjs — não editar manualmente.
import { createBankIcon } from "../createBankIcon";

/** Deutsche Bank Brasil — COMPE 487 */
export const DeutscheBank = createBankIcon({
  name: "Deutsche Bank Brasil",
  slug: "deutsche",
  compe: "487",
  color: "#0018a8",
  viewBox: "0 0 100.03096 100.03096",
  html: "<rect\n     style=\"fill:#0018a8;fill-opacity:1\"\n     id=\"deutsche_rect1\"\n     width=\"100.03096\"\n     height=\"100.03096\"\n     x=\"0\"\n     y=\"0\" />\n  <g transform=\"translate(20.6236,20.6236) scale(0.39189)\">\n    <path d=\"m 1,1 l 148,0 l 0,148 l -148,0 z m 21,21 l 0,107 l 107,0 l 0,-107 z m 68,15 l 27,0 l -56,77 l -27,0 z\" style=\"fill:#ffffff\" fill-rule=\"evenodd\" />\n  </g>",
});
